import React, {
  lazy,
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { TostMsg } from "../../../App";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Link, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { getTrans as T } from "../../../Shared/Language";
import { LazyImage } from "../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import {
  addEmployeeAwards,
  EmployeeAwardsGet,
  getEmployeeAwards,
} from "./Services/awardService";
import { Dropdown } from "primereact/dropdown";
import { getEmployeeList } from "../EmployeeList/Service/employeeService";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
const ComponentLoader = React.memo(
  lazy(() => import("../../../Shared/Sidebar/ComponentLoader"))
);

function AddAward() {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const toster = useContext(TostMsg);
  const { AwardId } = useParams();
  const { pathname } = useLocation();
  const { AddUserAward } = useParams();
  const [loading, setLoading] = useState(false);
  const [employeeList, setEmployeeList] = useState(null);
  const [masterCategoryData, setMasterCategoryData] = useState("");
  const [awardData, setAwardData] = useState("");
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const history = useHistory();
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const [guid, setGuid] = useState();

  useEffect(() => {
    getEmployeeIdData();
    GetCategoryEmployeeAwards();
    if (AwardId) {
      setTimeout(() => {
        getAwardList();
      }, 1000);
    } else {
      awardsForm.resetForm();
    }
  }, []);
  async function getAwardList() {
    setLoading(true);
    const params = {
      OrgId: userDetails.OrgId,
      LoggedInUserId: 0,
      year: "",
      Awardid: 0,
      AwardNumber: AwardId,
      PageNumber: 1,
      PageSize: 10,
      ModifiedBy: userDetails.EmpId,
    };
    try {
      const response = await getEmployeeAwards(params);
      let awardListData = response.Data[0];
      const awardsValue = {
        EmployeeId: awardListData.EmpId,
        orgAwardId: awardListData.OrgAwardId,
        Desc: awardListData.Desc,
        OrgId: awardListData.OrgId,
        date: awardListData?.Date?.split("T")[0],
      };
      awardsForm.setValues(awardsValue);
      setSelectedEmployee(awardListData?.EmpId);
      setAwardData(awardListData);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toster.current.error(ERROR_LIST.DefaultError);
    }
  }

  const AwardsValidation = Yup.object().shape({
    EmployeeId: Yup.string().required("Employee name is required."),
    orgAwardId: Yup.string().required("Award name is required."),
    date: Yup.string().required("Date is required."),
    Desc: "",
    // Desc: Yup.string().required("Description is required."),
  });

  const awardsForm = useFormik({
    initialValues: {
      EmployeeId: "",
      orgAwardId: "",
      date: "",
      Desc: "",
    },
    validationSchema: AwardsValidation,
    onSubmit: async (data) => {
      setLoading(true);
      const body = {
        OrgId: userDetails?.EmpKeyValues[0]?.OrgId,
        EmpId: Number(data.EmployeeId),
        Id: awardData?.id ?? 0,
        orgAwardId: Number(data.orgAwardId),
        Date: new Date(data.date).toISOString(),
        Desc: data?.Desc,
        ModifiedBy: userDetails?.EmpId,
      };
      try {
        await addEmployeeAwards(body);
        if (AwardId) {
          GetMasterSystemAlertList("Award_Updated", 0);
        } else {
          GetMasterSystemAlertList("Award_Added", 0);
        }
        setTimeout(() => {
          backToPage();
        }, 1000);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    },
  });

  useEffect(() => {
    if (employeeList?.length > 0 && AddUserAward) {
      let EmployeeGeioId = employeeList?.filter(
        (el) => el?.GUID == AddUserAward
      );
      const id = Number(EmployeeGeioId[0]?.EmpId);
      setSelectedEmployee(id);
      awardsForm.setFieldValue("EmployeeId", id);
    }
  }, [AddUserAward, employeeList]);

  const backToPage = () => {
    let getEmpGuid = employeeList?.filter(
      (el) => el?.EmpId == selectedEmployee
    );
    setGuid(getEmpGuid[0]?.GUID);
    const editUserAward = pathname.startsWith("/Edit/Award/");
    const addUserAward = pathname.startsWith("/Add/Award/");
    const editAward = pathname.startsWith("/Award/Edit/");
    const addAward = pathname.startsWith("/Award/Add");
    if (editAward) {
      history.push(`/Awards`);
    } else if (addAward) {
      history.push(`/Awards`);
    } else if (editUserAward && getEmpGuid[0]?.GUID) {
      history.push(`/Profile/${getEmpGuid[0]?.GUID}`);
    } else if (addUserAward && AddUserAward) {
      history.push(`/Profile/${AddUserAward}`);
    }
  };
  //For get the employee data.
  async function getEmployeeIdData() {
    var params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 0,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 10000000,
      EmployeeId: 0,
      IsSuggestedOnly: 0,
    };
    setLoading(true);
    try {
      let employeesList = await getEmployeeList(params);
      setEmployeeList(employeesList.Data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }
  const employeeOptionTemplate = (option) => {
    return (
      <div className="flex align-items-center gap-2 ticket-file-attach__items_detail">
        <LazyImage
          alt={option.FullName}
          src={option.ProfileImage}
          width="50"
          height="50"
        />
        <span>{`${option.FullName} (${option.EmpId})`}</span>
      </div>
    );
  };

  const AwardOptionTemplate = (option) => {
    return (
      <div className="flex align-items-center gap-2 ticket-file-attach__items_detail">
        <LazyImage
          alt={option.AwardName}
          src={option.awardImage}
          width="50"
          height="50"
        />
        <span>{option.AwardName}</span>
      </div>
    );
  };

  async function GetCategoryEmployeeAwards() {
    setLoading(true);
    let body = {
      OrgId: userDetails?.OrgId,
    };
    try {
      let responce = await EmployeeAwardsGet(body);
      setMasterCategoryData(responce?.Data);
    } catch (err) {
      toster.current.error(ERROR_LIST.AwardMasterData);
    } finally {
      setLoading(false);
    }
  }

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        // setMasterSystemAlertData(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        // setMasterSystemAlertData(msg?.Desc);
      }
    });
  }, []);

  return (
    <>
      <div id="circular-menu" className="circular-menu position-relation">
        <div className="items-wrapper">
          <div className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <Link
            className="menu-item is-flex right-panel-trigger"
            data-panel="languages-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <Link href="" className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <Link
            className="menu-item is-flex right-panel-trigger"
            data-panel="activity-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-grid"
            >
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </Link>
        </div>
      </div>
      <div className="container-fluid  position-relation">
        <div className="row">
          <div className="edit-ticket mb-4">
            <div className="w-100">
              <div className="row">
                <div className="col-md-8 shrink-w">
                  <div className="form-head d-flex flex-wrap align-items-center mb-4">
                    <div className="me-auto">
                      {AwardId ? (
                        <h2 className="font-w600 mb-0">{T("Edit Award")}</h2>
                      ) : (
                        <h2 className="font-w600 mb-0">{T("Add Award")}</h2>
                      )}
                    </div>
                    <div className="rightside-tabs">
                      <Link onClick={backToPage}>
                        <button className="back-newticket w-auto float-right">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            className="bi bi-arrow-left-short"
                            viewBox="0 0 16 16"
                          >
                            <path
                              fillRule="evenodd"
                              d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
                            />
                          </svg>{" "}
                          Back
                        </button>
                      </Link>
                    </div>
                  </div>
                  <form onSubmit={awardsForm.handleSubmit}>
                    <div className="row">
                      <div className="col-xl-12">
                        <div className="employee-card tile-grid tile-grid-v1">
                          <div id="feed-post-1" className="AnnouncementForm ">
                            <div className="third-section">
                              <div className="row">
                                <div className="mb-4 col-md-12">
                                  <label className="form-label-file">
                                    Select Employee
                                    <i className="inValidError">*</i>
                                  </label>
                                  <div className="cover-form">
                                    <i
                                      className="fa fa-user"
                                      aria-hidden="true"
                                    ></i>
                                    <Dropdown
                                      value={selectedEmployee}
                                      name="EmployeeId"
                                      options={employeeList}
                                      onChange={(e) => {
                                        setSelectedEmployee(e.value);
                                        awardsForm.setFieldValue(
                                          "EmployeeId",
                                          e.value
                                        );
                                      }}
                                      className="filledannoucement w-100"
                                      optionLabel="FullName"
                                      optionValue="EmpId"
                                      itemTemplate={employeeOptionTemplate}
                                      filter={true}
                                      placeholder="Choose..."
                                      checkmark={true}
                                      highlightOnSelect={false}
                                    />
                                  </div>
                                  <div className="invalid-feedback">
                                    {awardsForm.errors.EmployeeId &&
                                    awardsForm.touched.EmployeeId
                                      ? awardsForm.errors.EmployeeId
                                      : null}
                                  </div>
                                </div>
                                <div className="mb-4 col-md-12">
                                  <label className="form-label-file">
                                    Select Award
                                    <i className="inValidError">*</i>
                                  </label>
                                  <div className="cover-form">
                                    <i
                                      className="fa fa-trophy"
                                      aria-hidden="true"
                                    ></i>
                                    <Dropdown
                                      value={awardsForm?.values?.orgAwardId}
                                      onChange={(e) => {
                                        awardsForm.setFieldValue(
                                          "orgAwardId",
                                          e.value
                                        );
                                      }}
                                      options={masterCategoryData}
                                      className="filledannoucement w-100"
                                      optionLabel="AwardName"
                                      optionValue="id"
                                      itemTemplate={AwardOptionTemplate}
                                      placeholder="Choose..."
                                      checkmark={true}
                                      highlightOnSelect={false}
                                    />
                                  </div>
                                  <div className="invalid-feedback">
                                    {awardsForm.errors.orgAwardId &&
                                    awardsForm.touched.orgAwardId
                                      ? awardsForm.errors.orgAwardId
                                      : null}
                                  </div>
                                </div>
                                <div className="mb-4 col-md-12">
                                  <label className="form-label-file">
                                    Description
                                  </label>
                                  <div className="cover-form align-items-start">
                                    <i
                                      className="fa fa-file-text-o"
                                      aria-hidden="true"
                                    ></i>
                                    <textarea
                                      rows="7"
                                      cols="1"
                                      name="Desc"
                                      className={"form-control h-auto"}
                                      onFocus="this.Date"
                                      onChange={awardsForm.handleChange}
                                      value={awardsForm.values.Desc}
                                      placeholder="Description"
                                    ></textarea>
                                  </div>
                                  {/* <div className="invalid-feedback">
                                    {awardsForm.errors.Desc &&
                                    awardsForm.touched.Desc
                                      ? awardsForm.errors.Desc
                                      : null}
                                  </div> */}
                                </div>
                                <div className="mb-4 col-md-12">
                                  <label className="form-label-file">
                                    Date<i className="inValidError">*</i>
                                  </label>
                                  <div className="cover-form">
                                    <i
                                      className="fa fa-sticky-note-o"
                                      aria-hidden="true"
                                    ></i>
                                    {AwardId ? (
                                      <input
                                        type="date"
                                        name="date"
                                        onClick={(e) =>
                                          e.target.showPicker &&
                                          e.target.showPicker()
                                        }
                                        min={
                                          new Date(
                                            new Date() -
                                              30 * 24 * 60 * 60 * 1000
                                          )
                                            .toISOString()
                                            .split("T")[0]
                                        }
                                        className={
                                          "form-control" +
                                          (awardsForm.errors.date &&
                                          awardsForm.touched.date
                                            ? " is-invalid"
                                            : "")
                                        }
                                        onChange={awardsForm.handleChange}
                                        value={awardsForm.values.date}
                                        placeholder="Date"
                                      />
                                    ) : (
                                      <input
                                        type="date"
                                        name="date"
                                        onClick={(e) =>
                                          e.target.showPicker &&
                                          e.target.showPicker()
                                        }
                                        className={
                                          "form-control" +
                                          (awardsForm.errors.date &&
                                          awardsForm.touched.date
                                            ? " is-invalid"
                                            : "")
                                        }
                                        onChange={awardsForm.handleChange}
                                        value={awardsForm.values.date}
                                        placeholder="Date"
                                      />
                                    )}
                                  </div>
                                  <div className="invalid-feedback">
                                    {awardsForm.errors.date &&
                                    awardsForm.touched.date
                                      ? awardsForm.errors.date
                                      : null}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="btns-grp">
                          <Link onClick={backToPage}>
                            <button
                              className="cancelbtn-click"
                              fdprocessedid="5mw059"
                            >
                              Cancel
                            </button>
                          </Link>
                          <button
                            type="submit"
                            className="savebtn-click"
                            fdprocessedid="jjj57m"
                          >
                            {AwardId ? "Update" : "Save"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        {loading ? (
          <Suspense >
            <ComponentLoader />
          </Suspense>
        ) : (
          ""
        )}
      </div>
    </>
  );
}

export default AddAward;
